import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';

import { CoreModule } from '../core/core.module';
import { SharedModule } from '../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CurrencyMaskModule } from 'ng2-currency-mask';

import { StepApplicationComponent } from './application/application.component';
import { StepSummaryComponent } from './summary/step/summary/summary.component';
import { StepImportantDatesComponent } from './summary/step/important-dates/important-dates.component';
import {StepAppComponent} from './application/step/step.component';
import { ProjectModule } from '../project/project.module';
import { PrimaryAffiliationMultiselectComponent } from './components/primary-affiliation-multiselect/primary-affiliation-multiselect.component';
import { BusinessTypeMultiselectComponent } from './components/business-type-multiselect/business-type-multiselect.component';
import { OtherOrgsMultiselectComponent } from './components/other-orgs-multiselect/other-orgs-multiselect.component';

import { FiscalModule } from '../fiscal/fiscal.module';
// import { ProjectDetailsComponent } from './application/digital/project-details/project-details.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    ProjectModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    CurrencyMaskModule,
    FiscalModule,
    NgMultiSelectDropDownModule
  ],
  declarations: [
    StepApplicationComponent,
    StepSummaryComponent,
    // ProjectDetailsComponent,
    StepAppComponent,
    PrimaryAffiliationMultiselectComponent,
    BusinessTypeMultiselectComponent,
    OtherOrgsMultiselectComponent,
    StepImportantDatesComponent,
  ],
  entryComponents: [
    StepApplicationComponent
  ],
  exports: [
    StepApplicationComponent,
    StepSummaryComponent,
    StepAppComponent
  ],
  providers: []
})
export class StepModule {}
